mutation swapTokenToMphPermitted($inputToken: SwapTokenToMphPermittedInput!) {
  swapTokenToMphPermitted(inputToken: $inputToken)
}
